import React from 'react'

export default function Branding({ brand }) {
    if (!brand) return null
    return (
        <div className='story-branding'>
            {brand.logo && <img className="contentBrandLogo" src={brand.logo} alt={brand.logoAltText} />}
            {brand.copyright && <div className="readerFooter">{brand.copyright}</div>}
        </div>
    )
}
